module.exports = __webpack_public_path__ + "static/media/doclad6.dd1046b2.pdf";